(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    var roots = document.querySelectorAll("[data-unisource-faq]");
    if (!roots.length) return;

    roots.forEach(function (root) {
      var categoryButtons = Array.prototype.slice.call(
        root.querySelectorAll("[data-faq-category]")
      );

      if (!categoryButtons.length) return;

      function normalizeCategory(value) {
        return String(value || "")
          .toLowerCase()
          .trim()
          .replace(/&/g, "and")
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/^-+|-+$/g, "");
      }

      function findCategoryButton(value) {
        var normalized = normalizeCategory(value);
        if (!normalized) return null;

        return categoryButtons.find(function (button) {
          return normalizeCategory(button.getAttribute("data-faq-category")) === normalized;
        }) || null;
      }

      function updateAddressBar(category) {
        if (!window.history || typeof window.history.replaceState !== "function") return;

        try {
          var url = new URL(window.location.href);

          if (!category || category === "all") {
            url.searchParams.delete("category");
          } else {
            url.searchParams.set("category", category);
          }

          window.history.replaceState({}, "", url.pathname + url.search + url.hash);
        } catch (error) {
          // URL updates are optional; FAQ filtering still works without them.
        }
      }

      categoryButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          updateAddressBar(button.getAttribute("data-faq-category") || "all");
        });
      });

      var requestedCategory = "";

      try {
        requestedCategory = new URLSearchParams(window.location.search).get("category") || "";
      } catch (error) {
        requestedCategory = "";
      }

      var requestedButton = findCategoryButton(requestedCategory);
      if (!requestedButton) return;

      window.requestAnimationFrame(function () {
        requestedButton.click();

        window.setTimeout(function () {
          var target = root.querySelector("[data-faq-categories]") || root.querySelector("[data-faq-list]");
          if (target) {
            target.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }, 60);
      });
    });
  });
})();
